import { render, staticRenderFns } from "./newPurchase.vue?vue&type=template&id=28b2b5d3&"
import script from "./newPurchase.vue?vue&type=script&lang=ts&"
export * from "./newPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports